import { Avatar, Box, CircularProgress, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import { Alert, Pagination } from "@material-ui/lab";
import moment from "moment";
import { useEffect, useState } from "react";
import { useFirestoreQuery } from "../../../firebase/hooks";
import { firestore } from "../../../helpers/firebaseHelper";
import { IsNullOrEmpty, paginate } from "../../../helpers/utility";
const pageSize = 10;

export default function LeadSharing(props) {
    const { livestream, searchText, filter } = props;
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const livestreamsRef = firestore.collection('livestreams');
    const stream = useFirestoreQuery(
        livestreamsRef.where("id", "==", livestream)
    );

    useEffect(() => {
        setLoading(!loading)
    }, [stream])

    let filteredList = stream && stream[0] && stream[0].sharings;
    if (!filteredList) {
        filteredList = [];
    }

    if (!IsNullOrEmpty(searchText)) {
        filteredList = filteredList.filter((x) =>
            x.userName.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
    }

    if (!IsNullOrEmpty(filter)) {
        let startTime = moment().startOf('day');
        let endTime = moment().endOf('day');
        switch (filter) {
            case "Today":
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Week":
                startTime = moment().startOf("weeks");
                endTime = moment().endOf('weeks');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Month":
                startTime = moment().startOf('month');
                endTime = moment().endOf('month');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Year":
                startTime = moment().startOf('year');
                endTime = moment().endOf('year');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
        }
    }

    let totalPages = Math.ceil(filteredList.length / pageSize);
    filteredList = paginate(filteredList, pageSize, page);

    return <Grid container className="mt-4 pt-4" spacing={3}>
        <Grid item md={12} lg={12} xs={12} sm={12}>
            <Grid container>
                <Grid xs={12} sm={12}>
                    <Grid container>
                        <Grid item md={6} lg={6} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                            Date
                        </Grid>
                        <Grid item md={6} lg={6} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60  p-2">
                            Full Name
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} sm={12}>
                    {
                        filteredList.map((st) => {
                            return <>
                                <Grid container>
                                    <Grid item md={6} lg={6} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex flex-align-center">
                                        {moment.unix(st.createdAt).format("ll")}<br />
                                        {moment.unix(st.createdAt).format("hh:mm:ss a")}
                                    </Grid>
                                    <Grid item md={6} lg={6} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                                        <List disablePadding>
                                            <ListItem disableGutters className="p-0">
                                                <ListItemAvatar>
                                                    <Avatar style={{ background: "transparent", border: "2px solid #E38301", color: "#E38301" }}>{st.userName && st.userName[0]}</Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={st.userName} secondary={"@" + st.userName} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                </Grid>
                                <Divider />
                            </>
                        })
                    }
                    {
                        !loading && filteredList.length === 0 ?
                            IsNullOrEmpty(searchText) ?
                                <Alert severity="error" className="mt-4">No sharing leads available now</Alert> :
                                <Alert severity="error" className="mt-4">No sharing leads available for the selected criteria</Alert> :
                            ""
                    }
                    {
                        loading && <Box display={"flex"} alignItems={"center"} justifyContent={"center"} className="m-4">
                            <CircularProgress />
                        </Box>
                    }
                </Grid>
                <Grid xs={12} sm={12}>
                    {
                        filteredList.length > 0 &&

                        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} className="my-2">
                            <Pagination
                                shape="rounded"
                                variant="outlined"
                                count={totalPages}
                                page={page}
                                color="primary"
                                onChange={(e, pg) => {
                                    setPage(pg)
                                }} />
                        </Box>
                    }
                </Grid>
            </Grid>
        </Grid>
    </Grid>
}